import { Component, OnInit, ViewEncapsulation, ViewChild, ElementRef } from '@angular/core';
import { GlobalsService } from '@app/cp/shared/services/globals.service';
import { RefTrackingService } from '@app/cp/shared/services/reftracking.service';
import { TemplateFormData } from '@app/cp/shared/models/reftracking/TemplateFormData';
import { GridDataResult, PageChangeEvent } from '@progress/kendo-angular-grid';
import { NotificationSettings } from '@progress/kendo-angular-notification';
import { HubConnection } from '@aspnet/signalr';
import * as signalR from '@aspnet/signalr';
import { DropDownFilterSettings } from '@progress/kendo-angular-dropdowns';
import { SortDescriptor } from '@progress/kendo-data-query';
import { saveAs } from '@progress/kendo-file-saver';
import { FeatureFlagService } from "@app/cp/shared/services/feature-flag.service";

@Component({
    selector: 'reftrack-admin',
    templateUrl: './reftrack-admin.component.html',
    styleUrls: ['./reftrack-admin.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class RefTrackAdminComponent implements OnInit {

    public pageSizeT = 10;
    public skipT = 0;
    public gridViewTemplateDashBoard: GridDataResult;
    public pageSizeQ = 10;
    public skipQ = 0;
    public pageSizePopQ = 10;
    public skipPopQ = 0;
    public gridViewQuestionTemplateDashBoard: GridDataResult;
    errorMsg: any;
    public templatePDFSearch: string;
    public questionTemplateSearch: string;
    public fileType: string;
    public base64String: string = null;
    public Base64ImageStatic: string = null;
    public pdfBtnShow: boolean = true;
    public FileUploadShow: boolean = false;
    public PdfFileName: string;
    loading: boolean = false;
    public placeHolderCustomer: any = { CustomerID: '00000000-0000-0000-0000-000000000000', CustomerName: 'Select' };
    public dataCustomer: Array<{ CustomerID: string, CustomerName: string; }>;
    public dataFields: Array<{}>;
    public dataSteps: Array<{}>;
    public placeHolderQuestionType: any = { TypeCode: 0, TypeName: 'Select' };
    public placeHolderFieldType: any = { FieldTypeID: '00000000-0000-0000-0000-000000000000', FieldType: 'Not Applicable' };
    public dataQuestionType: Array<{ TypeCode: string, TypeName: string; }>;
    public dataFieldType: Array<{ FieldTypeID: string, FieldType: string; }>;
    public dataJSON: Array<{ JsonKey: string; }>;
    public selectedTab: number = 0;
    public featureFlagSet: any = {};
    constructor(private globals: GlobalsService, protected featureFlagService: FeatureFlagService, public refTrackingService: RefTrackingService) {

        this.featureFlagService.featureFlagSets.subscribe(data => {
            this.featureFlagSet = data;
        });
    }
    public hubConnection: HubConnection;
    public timeoutPDFTemplate: any;
    public timeoutQuestionTemplate: any;
    public timeoutImportQuestion: any;
    public sortDir: string = 'asc';
    public sortField: string = 'TemplateName';
    public sortDirT: string = 'asc';
    public sortFieldT: string = 'TemplateName';
    public currentSortT: SortDescriptor[] = [{ field: 'TemplateName', dir: 'asc' }];
    public currentSortQ: SortDescriptor[] = [{ field: 'TemplateName', dir: 'asc' }];
    public selectedFile: File | null = null;
    public static virtualizationSettings = { itemHeight: 30, pageSize: 100 };
    ngOnInit() {

        this.hubConnection = new signalR.HubConnectionBuilder()
            .configureLogging(signalR.LogLevel.Information)
            .withUrl(this.refTrackingService.SignalR)
            .build();

        // var connection = new signalR.HubConnectionBuilder()
        // .configureLogging(signalR.LogLevel.Information)
        // .withUrl(this.refTrackingService.SignalR)
        // .build();

        this.getFieldType();
        this.clear();
        this.onLoad();
        this.headingType = "";
        this.dataSteps = [];
    }
    onLoad() {
        this.getPDFTemplateDashBoard(this.templatePDFSearch, this.skipT, this.pageSizeT, this.sortFieldT, this.sortDirT);
        this.getQuestionTemplateDashBoard(this.questionTemplateSearch, this.skipQ, this.pageSizeQ, this.sortField, this.sortDir);
    }

    ddlCustomerValueChange(value: any, i) {
        for (var val in this.refTrackingService.TemplateConfig) {
            if (this.refTrackingService.TemplateConfig[val].CustomerID == value.CustomerId) {
                this.globals.notifyError('Customer cannot be duplicate');
                this.refTrackingService.TemplateConfig[i].CustomerID = '00000000-0000-0000-0000-000000000000';
            }
        }
    }
    ddlQuestionTypeValueChange(value: any, ind) {
        this.refTrackingService.questionResponseType = value.ComponentTypeID;
        if (value == 'dropdown') {
            for (var i in this.refTrackingService.allQuestionTemplate[ind].Options) {
                this.refTrackingService.allQuestionTemplate[ind].Options[i].PropertyType = false;
            }
        }
    }
    ddlPDFTempValueChange(value: any, st: number, op: number) {
        if (value == 'dropdown') {
            for (var i in this.refTrackingService.Step[st].StepControls[op].StepOptions) {
                this.refTrackingService.Step[st].StepControls[op].StepOptions[i].PropertyType = false;
            }
        }
        this.refTrackingService.questionResponseType = value.ComponentTypeID;
    }
    formData: TemplateFormData[];
    getTest() {
        let id: any = '9C2F913D-401B-EA11-AA1F-D7BD05DBB701';
        this.refTrackingService.getFormData(id).subscribe(data => {
            this.formData = data;
        });
    }
    getPDFTemplateDashBoard(searchText: any, skip: any, pageSize: any, sortField: string, sortDir: string) {
        this.loading = true;
        if (searchText == null || searchText == '') {
            searchText = 0;
        }
        this.refTrackingService.getPDFTemplateDashBoard(searchText, skip, pageSize, sortField, sortDir).subscribe(
            {
                next: data => {
                    var grdFields = JSON.parse(data).ItemDetails.PDFTemplateDetails.PDFTemplateDetails;
                    this.gridViewTemplateDashBoard = {
                        data: grdFields,
                        total: JSON.parse(data).ItemCount
                    };
                    this.loading = false;
                },
                error: (e) => {
                    console.error(e);
                    this.loading = false;
                }
            });
    }

    public pageChange(event: PageChangeEvent): void {
        this.skipT = event.skip;
        this.pageSizeT = event.take;
        this.getPDFTemplateDashBoard(this.templatePDFSearch, this.skipT, this.pageSizeT, this.sortFieldT, this.sortDir);
    }
    public pageChangeQuestion(event: PageChangeEvent): void {
        this.skipQ = event.skip;
        this.pageSizeQ = event.take;
        this.getQuestionTemplateDashBoard(this.questionTemplateSearch, this.skipQ, this.pageSizeQ, this.sortField, this.sortDir);
    }

    public sortChange(sort: SortDescriptor[]): void {
        this.skipT = 0;
        if (sort && sort.length > 0 && sort[0].dir) {
            this.sortFieldT = sort[0].field;
            this.sortDirT = sort[0].dir;
            this.currentSortT = sort;
        } else {
            this.sortFieldT = 'TemplateName';
            this.sortDirT = 'asc';
            this.currentSortT = [{ field: 'TemplateName', dir: 'asc' }];
        }
        // CreatedByName is resolved post-DB in C# — sort client-side on current page
        if (this.sortFieldT === 'CreatedByName') {
            if (this.gridViewTemplateDashBoard?.data) {
                const dir = this.sortDirT === 'asc' ? 1 : -1;
                const sorted = [...this.gridViewTemplateDashBoard.data].sort((a, b) =>
                    dir * (a.CreatedByName || '').localeCompare(b.CreatedByName || '')
                );
                this.gridViewTemplateDashBoard = { data: sorted, total: this.gridViewTemplateDashBoard.total };
            }
        } else {
            this.getPDFTemplateDashBoard(this.templatePDFSearch, this.skipT, this.pageSizeT, this.sortFieldT, this.sortDirT);
        }
    }

    public sortChangeQuestion(sort: SortDescriptor[]): void {
        this.skipQ = 0;
        if (sort && sort.length > 0 && sort[0].dir) {
            this.sortField = sort[0].field;
            this.sortDir = sort[0].dir;
            this.currentSortQ = sort;
        } else {
            this.sortField = 'TemplateName';
            this.sortDir = 'asc';
            this.currentSortQ = [{ field: 'TemplateName', dir: 'asc' }];
        }
        this.getQuestionTemplateDashBoard(this.questionTemplateSearch, this.skipQ, this.pageSizeQ, this.sortField, this.sortDir);
    }

    getQuestionTemplateDashBoard(searchText: any, skip: any, pageSize: any, sortField: string, sortDir: string) {
        this.loading = true;
        if (searchText == null || searchText == '') {
            searchText = 0;
        }
        this.refTrackingService.getQuestionTemplateDashBoard(searchText, skip, pageSize, sortField, sortDir).subscribe(
            {
                next: data => {
                    this.gridViewQuestionTemplateDashBoard = {
                        data: JSON.parse(data).ItemDetails,
                        total: JSON.parse(data).ItemCount
                    };
                    this.loading = false;
                },
                error: (e) => {
                    console.error(e);
                    this.loading = false;
                }
            });
    }

    getCustomers(SerchaText, TemplateId) {
        this.loading = true;
        this.refTrackingService.getCustomers(SerchaText, TemplateId).subscribe(data => {
            this.loading = false;
            this.dataCustomer = JSON.parse(data);
        });
    }
    getResponseType() {
        this.refTrackingService.getResponseType().subscribe(data => {
            this.dataQuestionType = JSON.parse(data);
        });
    }
    getTemplateConfiguration(TemplateId: any) {
        this.refTrackingService.getTemplateConfiguration(TemplateId).subscribe(data => {
            if (JSON.parse(data).ErrorCode == "0") {
                this.refTrackingService.TemplateConfig = JSON.parse(data).CustomerConfigDetails;
                this.refTrackingService.StepCompareB = JSON.stringify(this.refTrackingService.TemplateConfig);
                if (JSON.parse(data).DefaultConfigDetails.length > 0) {
                    this.refTrackingService.IsDefaultTemplate = JSON.parse(data).DefaultConfigDetails[0].IsDefaultTemplate;
                    this.refTrackingService.SelectTemplateConfigDefault.SentWithInvoice = JSON.parse(data).DefaultConfigDetails[0].SentWithInvoice;
                    this.refTrackingService.SelectTemplateConfigDefault.SavePDFCopy = JSON.parse(data).DefaultConfigDetails[0].SavePDFCopy;
                    this.refTrackingService.SelectTemplateConfigDefault.SendEmail = JSON.parse(data).DefaultConfigDetails[0].SendEmail;
                    this.refTrackingService.SelectTemplateConfigDefault.EmailAddresses = JSON.parse(data).DefaultConfigDetails[0].EmailAddresses;
                    this.refTrackingService.SelectTemplateConfigDefault.ConnectToAPI = JSON.parse(data).DefaultConfigDetails[0].ConnectToAPI;
                    this.refTrackingService.SelectTemplateConfigDefault.UserKey = JSON.parse(data).DefaultConfigDetails[0].UserKey;
                    this.refTrackingService.SelectTemplateConfigDefault.PassKey = JSON.parse(data).DefaultConfigDetails[0].PassKey;
                    this.refTrackingService.SelectTemplateConfigDefault.CustomerConfigID = JSON.parse(data).DefaultConfigDetails[0].CustomerConfigID;
                }
                else {
                    this.refTrackingService.IsDefaultTemplate = false;
                    this.refTrackingService.SelectTemplateConfigDefault.SentWithInvoice = false;
                    this.refTrackingService.SelectTemplateConfigDefault.SavePDFCopy = false;
                    this.refTrackingService.SelectTemplateConfigDefault.SendEmail = false;
                    this.refTrackingService.SelectTemplateConfigDefault.EmailAddresses = '';
                    this.refTrackingService.SelectTemplateConfigDefault.ConnectToAPI = false;
                    this.refTrackingService.SelectTemplateConfigDefault.UserKey = '';
                    this.refTrackingService.SelectTemplateConfigDefault.PassKey = '';
                    this.refTrackingService.SelectTemplateConfigDefault.CustomerConfigID = '00000000-0000-0000-0000-000000000000';
                }
            }
        });
    }
    keyPressTemplatePDF(event) {
        if (event.target.value.length > 2) {
            clearTimeout(this.timeoutPDFTemplate);
            this.timeoutPDFTemplate = setTimeout(() => {
                this.getPDFTemplateDashBoard(this.templatePDFSearch, this.skipT, this.pageSizeT, this.sortFieldT, this.sortDirT);
            }, 300);
        }
        else if (event.target.value.length == 0) {
            clearTimeout(this.timeoutPDFTemplate);
            this.timeoutPDFTemplate = setTimeout(() => {
                this.getPDFTemplateDashBoard(this.templatePDFSearch, this.skipT, this.pageSizeT, this.sortFieldT, this.sortDirT);
            }, 300);
        }
    }
    keyPressquestTemp(event) {
        if (event.target.value.length > 2) {
            clearTimeout(this.timeoutQuestionTemplate);
            this.timeoutQuestionTemplate = setTimeout(() => {
                this.skipQ = 0;
                this.getQuestionTemplateDashBoard(this.questionTemplateSearch, this.skipQ, this.pageSizeQ, this.sortField, this.sortDir);
            }, 300);
        }
        else if (event.target.value.length == 0) {
            clearTimeout(this.timeoutQuestionTemplate);
            this.timeoutQuestionTemplate = setTimeout(() => {
                this.skipQ = 0;
                this.getQuestionTemplateDashBoard(this.questionTemplateSearch, this.skipQ, this.pageSizeQ, this.sortField, this.sortDir);
            }, 300);
        }

    }
    public emailChecked = false;
    public apiChecked = false;
    clickConfigurations(dataItem, set) {
        this.getCustomers('0', dataItem.TemplateId);
        this.refTrackingService.IsSaveButton = true;
        this.refTrackingService.TemplateId = dataItem.TemplateId;
        this.refTrackingService.CreatedBY = dataItem.CreatedByName;
        this.refTrackingService.TemplateName = dataItem.TemplateName;
        this.refTrackingService.PDFFileName = dataItem.PDFFileName;
        this.refTrackingService.IsDefaultTemplate = dataItem.IsDefaultTemplate;
        // this.refTrackingService.selectTemplateConfig.CustomerId = dataItem.CustomerID;
        this.refTrackingService.saveType = 1; // 1 for configurations
        this.showSection(set, '- Configurations');
        this.getTemplateConfiguration(this.refTrackingService.TemplateId);
    }

    public section: number = 0;
    public headingType: string;
    showSection(sect, title) {
        this.section = sect;
        this.headingType = title;
    }
    clear() {
        //this.ConnectionId = '';
        this.gridViewTemplateDashBoard = null;
        this.refTrackingService.ComparePreview = [];
        this.refTrackingService.StepCompareB = "";
        this.refTrackingService.StepCompareA = "";
        this.refTrackingService.TemplateConfig = [];
        this.base64String = null;//value binded
        this.pdfBtnShow = false;//file upload button visibility
        this.Base64ImageStatic = null;
        this.refTrackingService.TemplateIdNewTemp = '';
        this.refTrackingService.VersionUniqueID = '';
        this.templatePDFSearch = '';
        this.questionTemplateSearch = '';
        this.refTrackingService.TemplateId = '';
        this.refTrackingService.CreatedBY = '';
        this.refTrackingService.TemplateName = '';
        this.refTrackingService.PDFFileName = '';
        this.refTrackingService.saveType = 0;
        // this.refTrackingService.templateDashboard = [];
        // this.refTrackingService.questionTemplateDashBoard = [];
        this.refTrackingService.selectQuestionTemplate = {
            QuestionTemplateName: '',
            QuestionType: '',
            PropertyType: '',
            Options: [],
            Title: '',
            Required: false,
            Base64Image: '',
            FieldTypeID: '00000000-0000-0000-0000-000000000000'
        };
        this.refTrackingService.selectFileUpload = {
            TemplateName: '',
            PdfFile: '',
        };
        this.refTrackingService.selectNewTemplateCreate = {
            QuestionType: '',
            PropertyType: '',
            Title: '',
            Field: '',
            StepOptions: [],
            Required: false,
            Base64Image: '',
            JsonKey: '',
            FieldTypeID: '00000000-0000-0000-0000-000000000000'

        };
        this.refTrackingService.SelectTemplateConfigDefault = {
            CustomerID: '00000000-0000-0000-0000-000000000000',
            SentWithInvoice: false,
            SavePDFCopy: false,
            SendEmail: false,
            EmailAddresses: '',
            ConnectToAPI: false,
            UserKey: '',
            PassKey: '',
            IsActive: false,
            IsDefaultTemplate: false,
            CustomerConfigID: '00000000-0000-0000-0000-000000000000',
            PostURL: ''
        };
        this.pageSizeT = 10;
        this.skipT = 0;
        this.pageSizeQ = 10;
        this.skipQ = 0;
        this.pageSizePopQ = 10;
        this.skipPopQ = 0;
        this.refTrackingService.Step = [];
        this.refTrackingService.StepControls = [];
        this.refTrackingService.StepOptions = [];
        this.refTrackingService.allQustOption = [];
        this.refTrackingService.newAttribute = {};
        this.refTrackingService.newAttributeSteps = {};
        this.refTrackingService.newAttributeAddOpt = {};
        this.StaticIst = 0;
        this.StaticIop = 0;
        this.refTrackingService.IsDefaultTemplate = false;
    }
    //public IsDefaultTemplateConfirmed = false;
    save() {
        if (this.refTrackingService.saveType == 1) {
            this.saveConfigurations();
        }
        else if (this.refTrackingService.saveType == 3)//save for Question Template
        {
            if (this.refTrackingService.selectQuestionTemplate.QuestionTemplateName == "") {
                this.globals.notifyError('Enter the Template Name');
            }
            else {
                if (this.validationQuestionSave()) {
                    this.saveNewQuestionTemplate();
                }
            }
        }
        else if (this.refTrackingService.saveType == 2)//Create New Template
        {
            if (this.validationPDFTemplateSave()) {
                this.saveNewTemplate();
            }
            else {
                this.OpenPdFConfirmation = true;
            }
        }

    }
    private FinalArrayCustomers: any;
    private FinalArrayDefault: any;
    saveConfigurations() {
        if (this.refTrackingService.IsDefaultTemplate == true) {
            this.FinalArrayDefault = {
                CustomerID: '00000000-0000-0000-0000-000000000000',
                SentWithInvoice: this.refTrackingService.SelectTemplateConfigDefault.SentWithInvoice,
                SavePDFCopy: this.refTrackingService.SelectTemplateConfigDefault.SavePDFCopy,
                SendEmail: this.refTrackingService.SelectTemplateConfigDefault.SendEmail,
                EmailAddresses: this.refTrackingService.SelectTemplateConfigDefault.EmailAddresses,
                ConnectToAPI: this.refTrackingService.SelectTemplateConfigDefault.ConnectToAPI,
                UserKey: this.refTrackingService.SelectTemplateConfigDefault.UserKey,
                PassKey: this.refTrackingService.SelectTemplateConfigDefault.PassKey,
                IsActive: false,
                IsDefaultTemplate: this.refTrackingService.IsDefaultTemplate,
                CustomerConfigID: this.refTrackingService.SelectTemplateConfigDefault.CustomerConfigID,
                PostURL: ''
            };
            this.FinalArrayCustomers = Array.from(this.refTrackingService.TemplateConfig);
            this.FinalArrayCustomers.push(this.FinalArrayDefault);
        }
        else {
            this.FinalArrayCustomers = Array.from(this.refTrackingService.TemplateConfig);
        }
        if (this.FinalArrayCustomers.length >= 0) {
            if (this.validationConfig(this.FinalArrayCustomers) == true) {
                var body = {
                    TemplateId: this.refTrackingService.TemplateId,
                    TempConfiguration: this.FinalArrayCustomers,
                };
                this.loading = true;
                this.refTrackingService.saveConfigurations(body).subscribe(data => {
                    this.loading = false;
                    if (JSON.parse(data).ErrorCode == 0) {
                        this.globals.notifyError(JSON.parse(data).ErrorMsg);
                        this.refTrackingService.saveType = 0;
                        this.clear();
                        this.showSection(0, '');
                        this.onLoad();
                    }
                    else if (JSON.parse(data).ErrorCode == 1) {
                        this.globals.notifyError(JSON.parse(data).ErrorMsg);
                        // this.refTrackingService.saveType = 0;
                        // this.clear();
                        // this.showSection(0, '');
                    }
                    else if (JSON.parse(data).ErrorCode == 2) {
                        this.globals.notifyError(JSON.parse(data).ErrorMsg);
                    }
                }
                    ,
                    error => {
                        this.errorMsg = error;
                    });
            }
        }

    }
    validationConfig(Arr) {
        let IsReturn: Boolean = false;
        for (var item in Arr) {
            if ((Arr[item].CustomerID == '00000000-0000-0000-0000-000000000000'
                || Arr[item].CustomerID == null) && this.refTrackingService.IsDefaultTemplate == false) {
                this.globals.notifyError('Please select the desired Customer');
                IsReturn = true;
                break;
            }
            else if (Arr[item].ConnectToAPI == true && Arr[item].UserKey == "" && Arr[item].PassKey == "") {
                this.globals.notifyError('please add UserKey and PassKey');
                IsReturn = true;
                break;
            }
            else if (Arr[item].SendEmail == true && this.validateEmailList(Arr[item].EmailAddresses) == 1) {
                var Email = this.validateEmailList(Arr[item].EmailAddresses);
                if (Email == 1) {
                    this.globals.notifyError('Please Enter Valid Email');
                    IsReturn = true;
                    break;
                }
            }
            var CustomerCount: number = 0;
            var CustID = Arr[item].CustomerID;
            for (var ItemCust in Arr) {
                if (Arr[ItemCust].CustomerID == CustID) {
                    CustomerCount = CustomerCount + 1;
                }
            }
            if (CustomerCount > 1) {
                if (this.refTrackingService.IsDefaultTemplate == true) {
                    this.globals.notifyError('Please select the desired Customer');
                }
                else {
                    this.globals.notifyError('Customer cannot be duplicate');
                }
                IsReturn = true;
                break;
            }
        }
        if (IsReturn == true) {
            return false;
        }
        else {
            return true;
        }
    }
    private QuestionTempFinalArray: any;
    saveNewQuestionTemplate() {
        this.QuestionTempFinalArray = Array.from(this.refTrackingService.allQuestionTemplate);
        this.QuestionTempFinalArray.push(this.refTrackingService.newAttributeAddOptQuest);
        var body = {
            QuestionTemplateID: this.refTrackingService.QuestionTemplateID,
            QuestionTemplateName: this.refTrackingService.selectQuestionTemplate.QuestionTemplateName,
            Controls: this.QuestionTempFinalArray,
        };
        console.log(body);
        this.loading = true;
        this.refTrackingService.saveNewQuestionTemplateSave(body).subscribe(data => {
            this.loading = false;
            if (JSON.parse(data).ErrorCode == 0) {
                this.globals.notifyError(JSON.parse(data).ErrorMsg);
                this.clear();
                this.refTrackingService.saveType = 0;
                this.showSection(0, '');
                this.onLoad();
                this.refTrackingService.QuestionTemplateID = this.refTrackingService.DefaultGUID;
            }
            else if (JSON.parse(data).ErrorCode == 1) {
                this.globals.notifyError(JSON.parse(data).ErrorMsg);
            }
        }
            ,
            error => {
                this.errorMsg = error;

            });
    }
    public addTemplatePDF() {
        this.loading = true;
        this.FileUploadShow = true;
        this.refTrackingService.IsSaveButton = false;
        this.refTrackingService.ISNextView = false;
        this.refTrackingService.selectFileUpload.TemplateName = '';
        this.refTrackingService.Step = [];
        this.refTrackingService.StepControls = [];
        this.refTrackingService.StepOptions = [];
        this.refTrackingService.newAttribute = {};
        this.refTrackingService.newAttributeAddOpt = {};
        this.refTrackingService.newAttribute = { PropertyType: false, Option: '', Fields: '' };
        this.refTrackingService.newAttributeAddOpt = { QuestionType: '', PropertyType: '', Title: '', Field: '', StepOptions: this.refTrackingService.StepOptions, Required: false, Base64Image: '', JsonKey: '' };
        this.getResponseType();
        this.getJson();
        this.showSection(3, '- Create New Template');
        this.loading = false;
        window.scrollTo(0, 0);
    }
    public addQuestTemp() {
        this.loading = true;
        this.refTrackingService.IsSaveButton = true;
        this.refTrackingService.QuestionTemplateID = this.refTrackingService.DefaultGUID;
        this.refTrackingService.allQuestionTemplate = [];
        this.refTrackingService.allQustOption = [];
        this.refTrackingService.newAttributeQuest = {};
        this.refTrackingService.newAttributeAddOptQuest = {};
        this.refTrackingService.newAttributeQuest = { PropertyType: false, Option: '' };;
        this.refTrackingService.newAttributeAddOptQuest = { QuestionType: '', PropertyType: '', Title: '', Options: this.refTrackingService.allQustOption, Required: false, Base64Image: '' };
        this.getResponseType();
        this.showSection(2, '- Question Template');
        this.refTrackingService.saveType = 3;
        this.loadQusTempOptions();
        this.loading = false;
        window.scrollTo(0, 0);
    }
    cancel() {
        if (this.refTrackingService.saveType == 2) {
            this.refTrackingService.StepCompareA = JSON.stringify(this.refTrackingService.Step);
            var Compare1 = this.getDifference(this.refTrackingService.StepCompareB, this.refTrackingService.StepCompareA);
            var Compare2 = (this.refTrackingService.ComparePreview.TemplateName == this.refTrackingService.selectFileUpload.TemplateName);
            if (Compare1 == false || Compare2 == false) {
                this.refTrackingService.deleteStatus = "CANCELPDF";
                this.opendDalogeDelete = true;
                this.refTrackingService.Confirmation = "Are you sure you want to quit without saving?";
            }
            else {
                this.cancelGroup();
            }
        }
        else if (this.refTrackingService.saveType == 3) {
            this.refTrackingService.StepCompareA = JSON.stringify(this.refTrackingService.allQuestionTemplate);
            var Compare = this.getDifference(this.refTrackingService.StepCompareB, this.refTrackingService.StepCompareA);
            if (Compare == false) {
                this.refTrackingService.deleteStatus = "CANCELPDF";
                this.opendDalogeDelete = true;
                this.refTrackingService.Confirmation = "Are you sure you want to quit without saving?";
            }
            else {
                this.cancelGroup();
            }
        }
        else if (this.refTrackingService.saveType == 1) {
            this.refTrackingService.StepCompareA = JSON.stringify(this.refTrackingService.TemplateConfig);

            var Compare = this.getDifference(this.refTrackingService.StepCompareB, this.refTrackingService.StepCompareA);
            if (Compare == false) {
                this.refTrackingService.deleteStatus = "CANCELPDF";
                this.opendDalogeDelete = true;
                this.refTrackingService.Confirmation = "Are you sure you want to quit without saving?";
            }
            else {
                this.cancelGroup();
            }
        }
        else {
            this.cancelGroup();
        }
    }
    cancelGroup() {
        this.showSection(0, '');
        this.refTrackingService.saveType = 0;
        this.clear();
        this.onLoad();
        window.scrollTo(0, 0);
        this.refTrackingService.deleteStatus = 0;
        this.opendDalogeDelete = false;
        this.refTrackingService.Confirmation = this.refTrackingService.ConfirmationText;
        this.hubConnection.stop();
    }

    @ViewChild('fileuploadPDF') fileuploadPDF: ElementRef;
    handleFileSelect(evt) {
        const files = evt.target.files;
        const file = files[0];

        if (file?.type === "application/pdf") {
            this.selectedFile = file;
            this.PdfFileName = file.name;
            this.fileType = file.type;
            this.pdfBtnShow = true;
        } else {
            this.selectedFile = null;
            this.PdfFileName = null;
            this.fileType = null;
            this.pdfBtnShow = false;
            this.fileuploadPDF.nativeElement.value = null;
            this.globals.notifyError("Only Accepting PDF");
        }
    }

    fileUplaod() {
        if (this.refTrackingService.selectFileUpload.TemplateName.trim() === '') {
            this.globals.notifyError('Enter the Template Name');
            return;
        }

        if (!this.selectedFile) {
            this.globals.notifyError('Please select File to upload');
            return;
        }

        // Create FormData with proper field names
        const formData = new FormData();
        formData.set('PdfFile', this.selectedFile);
        formData.set('TemplateName', this.refTrackingService.selectFileUpload.TemplateName);
        formData.set('PdfFileName', this.PdfFileName);
        formData.set('TemplateID', this.refTrackingService.TemplateIdNewTemp || '');
        formData.set('VersionUniqueID', this.refTrackingService.VersionUniqueID || '');

        this.loading = true;

        this.refTrackingService.fileUpload(formData).subscribe({
            next: (response) => {
                const data = response;
                this.loading = false;

                if (data.ErrorCode === 0) {
                    this.globals.notifySuccess("File Uploaded Successfully");
                    this.dataFields = data.PdfFields;
                    this.refTrackingService.TemplateIdNewTemp = data.TemplateId;
                    this.refTrackingService.VersionUniqueID = data.VersionUniqueID;
                    this.resetPdfTemplateSteps(this.refTrackingService.TemplateIdNewTemp, this.refTrackingService.VersionUniqueID);
                    this.showSection(5, '- Create New Template');
                    this.refTrackingService.saveType = 2;
                    this.pdfBtnShow = false;
                    this.dataSteps = [];
                } else if (data.ErrorCode === 1) {
                    this.globals.notifyError(data.ErrorMsg);
                }
            },
            error: (error) => {
                this.loading = false;
                this.errorMsg = error;
                this.globals.notifyError('Error uploading file');
            }
        });
    }

    resetPdfTemplateSteps(TemplateID, VersionUniqueID) {
        this.loading = true;
        for (var item in this.refTrackingService.Step) {
            for (var StepControls in this.refTrackingService.Step[item].StepControls) {
                var ct = this.dataFields.filter(x => x === this.refTrackingService.Step[item].StepControls[StepControls].Field).length;
                if (ct == 0) {
                    this.refTrackingService.Step[item].StepControls[StepControls].Field = "";
                }

                for (var optionss in this.refTrackingService.Step[item].StepControls[StepControls].StepOptions) {
                    var ct = this.dataFields.filter(x => x === this.refTrackingService.Step[item].StepControls[StepControls].StepOptions[optionss].Fields).length;
                    if (ct == 0) {
                        this.refTrackingService.Step[item].StepControls[StepControls].StepOptions[optionss].Fields = "";
                    }
                }
            }
        }
        this.loading = false;
    }
    private FinalArrayPDFTemp: any;
    saveNewTemplate() {
        this.FinalArrayPDFTemp = Array.from(this.refTrackingService.Step);
        this.FinalArrayPDFTemp.push(this.refTrackingService.newAttributeSteps);
        var body = {
            TemplateName: this.refTrackingService.selectFileUpload.TemplateName,
            TemplateId: this.refTrackingService.TemplateIdNewTemp,
            VersionUniqueID: this.refTrackingService.VersionUniqueID,
            Steps: this.FinalArrayPDFTemp,
        };
        this.loading = true;
        this.refTrackingService.saveNewTemplate(body).subscribe(data => {
            if (JSON.parse(data).ErrorCode == 0) {
                this.loading = false;
                this.globals.notifySuccess("Data saved Successfully");
                this.refTrackingService.StepNo = 1;
                this.getTemplateForms();
                this.getJsonPreview();
                this.refTrackingService.ISNextView = true;
                this.refTrackingService.StepCompareB = JSON.stringify(this.refTrackingService.Step);

            }
            else if (JSON.parse(data).ErrorCode == 1) {
                this.loading = false;
                this.globals.notifyError(JSON.parse(data).ErrorMsg);
                this.refTrackingService.ISNextView = false;
            }
        }
            ,
            error => {
                this.errorMsg = error;
            });
    }
    onAddData(st, op) {
        this.refTrackingService.newAttribute = { PropertyType: false, Option: '', Fields: '' };
        this.refTrackingService.Step[st].StepControls[op].StepOptions.push(this.refTrackingService.newAttribute);
        this.refTrackingService.newAttribute = {};
    }

    onAddOption(st) {
        let v: number;
        v = this.refTrackingService.Step[st].StepControls.length;
        this.refTrackingService.newAttributeAddOpt = { QuestionType: '', PropertyType: '', Title: '', Field: '', StepOptions: this.refTrackingService.StepOptions, Required: false, Base64Image: '', JsonKey: '' };
        this.refTrackingService.newAttribute = { PropertyType: false, Option: '', Fields: '' };
        this.refTrackingService.Step[st].StepControls.push(this.refTrackingService.newAttributeAddOpt);
        this.refTrackingService.newAttributeAddOpt = {};
        this.refTrackingService.Step[st].StepControls[v].StepOptions = [];
        this.refTrackingService.Step[st].StepControls[v].StepOptions.push(this.refTrackingService.newAttribute);
        this.refTrackingService.newAttribute = {};
    }
    loadPDFOptions() {
        this.refTrackingService.newAttributeSteps = { Step: '', StepTitle: '', StepControls: this.refTrackingService.StepControls };
        this.refTrackingService.Step.push(this.refTrackingService.newAttributeSteps);
        this.refTrackingService.newAttributeSteps = {};
        this.refTrackingService.Step[0].StepControls.push(this.refTrackingService.newAttributeAddOpt);
        this.refTrackingService.newAttributeAddOpt = {};
        this.refTrackingService.Step[0].StepControls[0].StepOptions.push(this.refTrackingService.newAttribute);
        this.refTrackingService.newAttribute = {};
    }
    deletePDFSubOption(i, j, k) {
        if (this.refTrackingService.Step[i].StepControls[j].StepOptions.length > 1) {
            this.refTrackingService.deleteStatus = "DPDFSUBOPTION";
            this.DelPDFOptTopIndex = i;
            this.DelPDFOptInnerIndex = j;
            this.DelPDFSubOptionIndex = k;
            this.opendDalogeDelete = true;
        }
    }

    //Question Template Options
    loadQusTempOptions() {
        this.refTrackingService.allQuestionTemplate.push(this.refTrackingService.newAttributeAddOptQuest);
        this.refTrackingService.newAttributeAddOptQuest = {};
        this.refTrackingService.allQuestionTemplate[0].Options.push(this.refTrackingService.newAttributeQuest);
        this.refTrackingService.newAttributeQuest = {};
    }
    onAddSubQuestData(op) {
        this.refTrackingService.newAttributeQuest = {};
        this.refTrackingService.newAttributeQuest = { PropertyType: false, Option: '' };
        this.refTrackingService.allQuestionTemplate[op].Options.push(this.refTrackingService.newAttributeQuest);
        this.refTrackingService.newAttributeQuest = {};
    }
    onAddQuestOption(index) {
        let v: number;
        v = this.refTrackingService.allQuestionTemplate.length;
        this.refTrackingService.newAttributeAddOptQuest = { QuestionType: '', PropertyType: '', Title: '', Options: this.refTrackingService.allQustOption, Required: false, Base64Image: '' };
        this.refTrackingService.newAttributeQuest = { PropertyType: false, Option: '' };
        this.refTrackingService.allQuestionTemplate.push(this.refTrackingService.newAttributeAddOptQuest);
        this.refTrackingService.newAttributeAddOptQuest = {};
        this.refTrackingService.allQuestionTemplate[v].Options = [];
        this.refTrackingService.allQuestionTemplate[v].Options.push(this.refTrackingService.newAttributeQuest);
        this.refTrackingService.newAttributeQuest = {};
    }
    deleteQuestSubOption(index, j) {
        if (this.refTrackingService.allQuestionTemplate[index].Options.length > 1) {
            this.refTrackingService.deleteStatus = "DQINNEROPTION";
            this.deleteQuestOptionsIndex = index;
            this.deleteQuestOptionsInnerIndex = j;
            this.opendDalogeDelete = true;
        }
    }
    public deleteQuestOptionsInnerIndex: number = null;
    public deleteQuestOptionsIndex: number = null;
    deleteQuestOptions(index) {
        this.refTrackingService.deleteStatus = "DQUESTOPTION";
        this.deleteQuestOptionsIndex = index;
        this.opendDalogeDelete = true;
    }
    public DelPDFOptTopIndex: number = null;
    public DelPDFOptInnerIndex: number = null;
    public DelPDFSubOptionIndex: number = null;
    deletePDFOptions(i, j) {
        this.refTrackingService.deleteStatus = "DPDFOPTION";
        this.DelPDFOptTopIndex = i;
        this.DelPDFOptInnerIndex = j;
        this.opendDalogeDelete = true;
    }
    deletePDFDashboard(TemplateId) {
        this.loading = true;
        this.refTrackingService.deletePDFTemplateDashForms(TemplateId).subscribe(data => {
            if (JSON.parse(data).ErrorCode == 0) {
                this.globals.notifySuccess("Deleted Successfully");
                this.opendDalogeDelete = false;
                this.getPDFTemplateDashBoard(this.templatePDFSearch, this.skipT, this.pageSizeT, this.sortFieldT, this.sortDirT);
                this.refTrackingService.deletePDFTemplateId = 0;
                this.refTrackingService.deleteStatus = 0;
            }
            else if (JSON.parse(data).ErrorCode == 1) {
                this.globals.notifyError(JSON.parse(data).ErrorMsg);
                this.opendDalogeDelete = false;
                this.refTrackingService.deletePDFTemplateId = 0;
                this.refTrackingService.deleteStatus = 0;
            }
            else {
                this.globals.notifyError(JSON.parse(data).ErrorMsg);
                this.opendDalogeDelete = false;
                this.refTrackingService.deletePDFTemplateId = 0;
                this.refTrackingService.deleteStatus = 0;
            }
        });
        this.loading = false;
    }
    deleteQuestDashboard(FieldOptionsCatId) {
        this.loading = true;
        this.refTrackingService.deleteQuestemplateDashForms(FieldOptionsCatId).subscribe(data => {
            if (JSON.parse(data).ErrorCode == 0) {
                this.globals.notifySuccess("Deleted Successfully");
                this.opendDalogeDelete = false;
                this.getQuestionTemplateDashBoard(this.questionTemplateSearch, this.skipQ, this.pageSizeQ, this.sortField, this.sortDir);
                this.refTrackingService.deletePDFTemplateId = 0;
                this.refTrackingService.deleteStatus = 0;
            }
        });
        this.loading = false;
    }
    public opendDalogeDelete = false;
    public OpenIsDefault = false;

    public deletePDFdashboardShow(dataItem, Type: string) {
        if (Type == 'Temp') {
            this.refTrackingService.deletePDFTemplateId = dataItem.TemplateId;
            this.refTrackingService.deleteStatus = Type;
        }
        else if (Type == 'Quest') {
            this.refTrackingService.deleteStatus = Type;
            this.refTrackingService.deletePDFTemplateId = dataItem.FieldOptionsCatId;
        }
        this.opendDalogeDelete = true;
    }
    public close(status) {
        if (status == '0' || status == 'cancel') {
            this.refTrackingService.Confirmation = this.refTrackingService.ConfirmationText;
            this.opendDalogeDelete = false;
        }
        else if (status == '1') {
            if (this.refTrackingService.deleteStatus == 'Temp') {
                this.deletePDFDashboard(this.refTrackingService.deletePDFTemplateId);
            }
            else if (this.refTrackingService.deleteStatus == 'Quest') {
                this.deleteQuestDashboard(this.refTrackingService.deletePDFTemplateId);
            }
            else if (this.refTrackingService.deleteStatus == 'DQUESTOPTION') {
                if (this.refTrackingService.allQuestionTemplate.length >= 0) {
                    this.refTrackingService.allQuestionTemplate.splice(this.deleteQuestOptionsIndex, 1);
                }
                this.refTrackingService.deleteStatus = 0;
                this.deleteQuestOptionsIndex = null;
                this.opendDalogeDelete = false;
            }
            else if (this.refTrackingService.deleteStatus == 'DPDFOPTION') {
                if (this.refTrackingService.Step[this.DelPDFOptTopIndex].StepControls.length >= 0) {
                    this.refTrackingService.Step[this.DelPDFOptTopIndex].StepControls.splice(this.DelPDFOptInnerIndex, 1);
                    if (this.refTrackingService.Step[this.DelPDFOptTopIndex].StepControls.length == 0) {
                        this.refTrackingService.Step.splice(this.DelPDFOptTopIndex, 1);
                        this.dataSteps = [];
                        for (var Count in this.refTrackingService.Step) {
                            let Val: any = Number(Count) + 1;
                            this.dataSteps.push(Val);
                            if (this.refTrackingService.Step.length > 0) {
                                this.refTrackingService.Step[Count].StepNumber = Val.toString();
                            }
                        }
                    }
                }
                this.refTrackingService.deleteStatus = 0;
                this.DelPDFOptTopIndex = null;
                this.DelPDFOptInnerIndex = null;
                this.opendDalogeDelete = false;
            }
            else if (this.refTrackingService.deleteStatus == 'DQINNEROPTION') {
                this.refTrackingService.allQuestionTemplate[this.deleteQuestOptionsIndex].Options.splice(this.deleteQuestOptionsInnerIndex, 1);
                this.refTrackingService.deleteStatus = 0;
                this.deleteQuestOptionsIndex = null;
                this.deleteQuestOptionsInnerIndex = null;
                this.opendDalogeDelete = false;
            }
            else if (this.refTrackingService.deleteStatus == 'DPDFSUBOPTION') {
                this.refTrackingService.Step[this.DelPDFOptTopIndex].StepControls[this.DelPDFOptInnerIndex].StepOptions.splice(this.DelPDFSubOptionIndex, 1);
                this.refTrackingService.deleteStatus = 0;
                this.DelPDFOptTopIndex = null;
                this.DelPDFOptInnerIndex = null;
                this.DelPDFSubOptionIndex = null;
                this.opendDalogeDelete = false;
            }
            else if (this.refTrackingService.deleteStatus == 'CANCELPDF') {
                this.cancelGroup();
            }
            else if (this.refTrackingService.deleteStatus == 'DCUSTOMER') {
                this.refTrackingService.TemplateConfig.splice(Number(this.CustTopIndex), 1);
                this.refTrackingService.deleteStatus = "DCUSTOMER";
                this.CustTopIndex = null;
                this.opendDalogeDelete = false;
            }
        }
    }

    copyQuest(i) {
        this.refTrackingService.allQustOption = [];
        let v: number;
        v = this.refTrackingService.allQuestionTemplate.length;
        this.refTrackingService.newAttributeAddOptQuest = { QuestionType: '', PropertyType: '', Title: '', Options: this.refTrackingService.allQustOption, Required: false, Base64Image: '' };
        this.refTrackingService.allQuestionTemplate.push(this.refTrackingService.newAttributeAddOptQuest);
        this.refTrackingService.newAttributeAddOptQuest = {};
        this.refTrackingService.QustOptRowCount = this.refTrackingService.allQuestionTemplate.length;
        this.refTrackingService.allQuestionTemplate[v].QuestionType = this.refTrackingService.allQuestionTemplate[i].QuestionType;
        this.refTrackingService.allQuestionTemplate[v].Title = this.refTrackingService.allQuestionTemplate[i].Title;
        this.refTrackingService.allQuestionTemplate[v].PropertyType = this.refTrackingService.allQuestionTemplate[i].PropertyType;
        let ii: number = -1;
        for (ii = 0; ii <= (this.refTrackingService.allQuestionTemplate[i].Options.length - 1); ii++) {
            let SubOption = {
                Option: this.refTrackingService.allQuestionTemplate[i].Options[ii].Option,
                PropertyType: this.refTrackingService.allQuestionTemplate[i].Options[ii].PropertyType
            };
            this.refTrackingService.allQuestionTemplate[v].Options.push(SubOption);
        }
    }
    addSteps() {
        let length: any = this.refTrackingService.Step.length;
        this.refTrackingService.newAttribute = {};
        this.refTrackingService.newAttributeSteps = {};
        this.refTrackingService.newAttributeAddOpt = {};
        this.refTrackingService.StepOptions = [];
        this.refTrackingService.StepControls = [];
        this.refTrackingService.IsSaveButton = true;
        this.refTrackingService.newAttribute = { PropertyType: false, Option: '', Fields: '' };
        this.refTrackingService.newAttributeSteps = { StepNumber: '', StepTitle: '', StepControls: this.refTrackingService.StepControls };
        this.refTrackingService.newAttributeAddOpt = { QuestionType: '', PropertyType: '', Title: '', Field: '', StepOptions: this.refTrackingService.StepOptions, Required: false, Base64Image: '', JsonKey: '' };
        this.refTrackingService.Step.push(this.refTrackingService.newAttributeSteps);
        this.refTrackingService.newAttributeSteps = {};
        this.refTrackingService.Step[length].StepControls.push(this.refTrackingService.newAttributeAddOpt);
        this.refTrackingService.newAttributeAddOpt = {};
        this.refTrackingService.Step[length].StepControls[0].StepOptions.push(this.refTrackingService.newAttribute);
        this.refTrackingService.newAttribute = {};
        this.dataSteps.push(this.refTrackingService.Step.length);
        this.refTrackingService.Step[this.refTrackingService.Step.length - 1].StepNumber = this.refTrackingService.Step.length.toString();
    }
    getdate() {
        let newDate = new Date();
        return newDate;
    }
    //for Mbile preview
    getTemplateForms() {
        this.refTrackingService.getTemplateForms(this.refTrackingService.TemplateIdNewTemp, this.refTrackingService.StepNo).subscribe(data => {
            this.refTrackingService.PreviewDataList = data;
            if (this.refTrackingService.PreviewDataList == null || this.refTrackingService.PreviewDataList.length == 0) {
                this.globals.notifyError("Error while loading Preview");
            }
            else {
                this.forDateConvertion(this.refTrackingService.PreviewDataList);
                if (this.refTrackingService.PreviewDataList[0].stepNumber == this.refTrackingService.PreviewDataList[0].totStepCount) {
                    this.refTrackingService.NextButtonText = "Finish";
                }
                else {
                    this.refTrackingService.NextButtonText = "Next";
                }
                if (this.refTrackingService.PreviewDataList[0].stepNumber == 1) {
                    this.refTrackingService.IsPreView = false;
                }
                else {
                    this.refTrackingService.IsPreView = true;
                }
            }
        });
    }
    forDateConvertionTemplateEdit(array: any) {
        for (var item in array) {
            for (var inneritem in array[item].StepControls) {
                if (array[item].StepControls[inneritem].QuestionType == "datepicker") {
                    if (array[item].StepControls[inneritem].PropertyType == "") {
                        array[item].StepControls[inneritem].PropertyType = this.getDate(array[item].StepControls[inneritem].PropertyType);
                    }
                    else {
                        array[item].StepControls[inneritem].PropertyType = this.getDate(array[item].StepControls[inneritem].PropertyType);
                    }
                }
            }
        }
    }
    forDateConvertion(array: any) {
        for (var item in array) {
            for (var inneritem in array[item].formComponent) {
                if (array[item].formComponent[inneritem].componentType == "datepicker") {
                    if (array[item].formComponent[inneritem].defaultValue == "") {
                        array[item].formComponent[inneritem].defaultValue = this.getDate(array[item].formComponent[inneritem].defaultValue);
                    }
                    else {
                        array[item].formComponent[inneritem].defaultValue = this.getDate(array[item].formComponent[inneritem].defaultValue);
                    }
                }
            }
        }
    }
    getDate(date: any) {
        let dateString: any;
        if (date == null || date == '') {
            dateString = new Date();
        }
        else {
            dateString = date;
        }
        let newDate = new Date(dateString);
        return newDate;
    }

    getTeplatePDFEdit(dataItem) {
        this.FileUploadShow = true;
        this.refTrackingService.TemplateIdNewTemp = dataItem.TemplateId;
        this.refTrackingService.VersionUniqueID = dataItem.VersionUniqueID;
        this.refTrackingService.PDFFileName = dataItem.PDFFileName;
        this.refTrackingService.selectFileUpload.PdfFile = '';
        this.loading = true;
        this.refTrackingService.CheckPDFTemplateIsBlocked(this.refTrackingService.TemplateIdNewTemp, "PDF").subscribe(data => {
            if (JSON.parse(data).ErrorCode == 0) {
                this.loading = false;
                if (JSON.parse(data).IsLocked == "False") {
                    this.signalR().then(value => {
                        this.GetConnectionID().then(value => {
                            this.checkSignalR(dataItem.TemplateId, "PDF");
                        });
                    });
                    this.getPdfTemplate(dataItem.TemplateId, dataItem.VersionUniqueID);
                }
                else {
                    this.globals.notifyError(JSON.parse(data).ErrorMsg);
                }
            }

        });
    }
    getPdfTemplate(TemplateID, VersionUniqueID) {
        this.loading = true;
        this.refTrackingService.getSteps(TemplateID, VersionUniqueID).subscribe(data => {
            if (JSON.parse(data).ErrorCode == 0) {
                this.refTrackingService.ComparePreview = JSON.parse(data);
                this.loading = false;
                this.getResponseType();
                this.getJson();
                this.refTrackingService.IsSaveButton = true;
                this.forDateConvertionTemplateEdit(JSON.parse(data).TemplateDetails.Steps);//date Converstion String to date
                this.refTrackingService.selectFileUpload.TemplateName = JSON.parse(data).TemplateName;
                this.refTrackingService.newAttribute = {};
                this.refTrackingService.newAttributeSteps = {};
                this.refTrackingService.newAttributeAddOpt = {};
                this.refTrackingService.StepOptions = [];
                this.refTrackingService.StepControls = [];
                this.refTrackingService.newAttribute = { PropertyType: true, Option: '', Fields: '' };
                this.refTrackingService.newAttributeAddOpt = { QuestionType: '', PropertyType: '', Title: '', Field: '', StepOptions: this.refTrackingService.StepOptions, Required: false, Base64Image: '', JsonKey: '' };
                for (var item in JSON.parse(data).TemplateDetails.Steps) {
                    this.refTrackingService.newAttributeSteps = JSON.parse(data).TemplateDetails.Steps[item];
                    this.refTrackingService.Step.push(this.refTrackingService.newAttributeSteps);
                    this.refTrackingService.newAttributeSteps = {};
                    for (var StepControls in JSON.parse(data).TemplateDetails.Steps[item].StepControls) {
                        this.refTrackingService.Step[item].StepControls[StepControls].StepOptions = [];
                        if (JSON.parse(data).TemplateDetails.Steps[item].StepControls[StepControls].QuestionType.toUpperCase() == 'CHECKBOX' || JSON.parse(data).TemplateDetails.Steps[item].StepControls[StepControls].QuestionType.toUpperCase() == 'DROPDOWN' || JSON.parse(data).TemplateDetails.Steps[item].StepControls[StepControls].QuestionType.toUpperCase() == 'COMBOBOX') {
                            for (var optionss in JSON.parse(data).TemplateDetails.Steps[item].StepControls[StepControls].StepOptions) {
                                let value: boolean;
                                let SubOption = {
                                    Option: JSON.parse(data).TemplateDetails.Steps[item].StepControls[StepControls].StepOptions[optionss].Option,
                                    PropertyType: JSON.parse(data).TemplateDetails.Steps[item].StepControls[StepControls].StepOptions[optionss].PropertyType,
                                    Fields: JSON.parse(data).TemplateDetails.Steps[item].StepControls[StepControls].StepOptions[optionss].Fields
                                };
                                this.refTrackingService.Step[item].StepControls[StepControls].StepOptions.push(SubOption);
                            }
                        }
                    }
                }
                this.refTrackingService.StepCompareB = JSON.stringify(this.refTrackingService.Step);
                this.refTrackingService.selectFileUpload.PdfFile = JSON.parse(data).Base64File;
                this.dataFields = JSON.parse(data).PdfFields;
                this.showSection(5, '- Edit PDF Template');
                this.refTrackingService.saveType = 2;
                this.refTrackingService.StepNo = 1;
                this.getTemplateForms();
                this.getJsonPreview();
                this.dataSteps = [];
                this.getStepCount();
                this.refTrackingService.ISNextView = true;
            }
            else if (JSON.parse(data).ErrorCode == 1) {
                this.getResponseType();
                this.getJson();
                this.refTrackingService.ComparePreview = JSON.parse(data);
                this.refTrackingService.StepCompareB = JSON.stringify(this.refTrackingService.Step);
                this.refTrackingService.selectFileUpload.TemplateName = JSON.parse(data).TemplateName;
                this.dataFields = JSON.parse(data).PdfFields;
                this.refTrackingService.selectFileUpload.PdfFile = JSON.parse(data).Base64File;
                this.showSection(5, '- Edit PDF Template');
                this.refTrackingService.saveType = 2;
                this.refTrackingService.ISNextView = false;
            }
            this.loading = false;
        });
    }
    SaveBlockPDFTemplate(TemplateID, TempateType, ConnectionID) {
        this.refTrackingService.SaveBlockPDFTemplate(TemplateID, TempateType, ConnectionID).subscribe(data => {
            if (JSON.parse(data).ErrorCode == 0) {
                sessionStorage.removeItem("ConectionId");
            }
        });
    }
    GetConnectionID() {
        return new Promise(resolve => {
            this.hubConnection.invoke('GetConnectionId')
                .then(function (connectionId) {
                    sessionStorage.setItem('ConectionId', connectionId);
                    resolve(true);
                }).catch(err => console.error(err.toString()));
        });
    }
    signalR() {
        return new Promise(resolve => {
            this.hubConnection.start().then(function () {
                resolve(true);
            }).catch(function (err) {
                return console.error(err.toString());
            });

        });
    }

    checkSignalR(TemplateId, TemplateType) {
        if (sessionStorage.getItem("ConectionId") != null) {
            this.SaveBlockPDFTemplate(TemplateId, TemplateType, sessionStorage.getItem("ConectionId"));
        }

    }
    public openQuest: boolean;
    popUpQuestTemp() {
        this.SearchQuestPopUP = '';
        this.openQuest = !this.openQuest;

    }
    public SearchQuestPopUP: string = '';
    public ImportIndexSt: number = 0;
    public ImportIndexOp: number = 0;
    importQuestianTemplate(st, op) {
        this.gridViewQuestionTemplateDashBoard = null;
        this.ImportIndexSt = st;
        this.ImportIndexOp = op;
        this.skipPopQ = 0;
        this.pageSizePopQ = 10;
        this.getQuestionTemplateDashBoard(this.SearchQuestPopUP, this.skipPopQ, this.pageSizePopQ, this.sortField, this.sortDir);
        this.popUpQuestTemp();
    }
    public pageChangePopUpQuestion(event: PageChangeEvent): void {
        this.skipPopQ = event.skip;
        this.pageSizePopQ = event.take;
        this.getQuestionTemplateDashBoard(this.SearchQuestPopUP, this.skipPopQ, this.pageSizePopQ, this.sortField, this.sortDir);
    }
    onKeyPressPopUpQuest(event) {
        if (event.target.value.length > 2) {
            clearTimeout(this.timeoutImportQuestion);
            this.timeoutImportQuestion = setTimeout(() => {
                this.getQuestionTemplateDashBoard(this.SearchQuestPopUP, this.skipPopQ, this.pageSizePopQ, this.sortField, this.sortDir);
            }, 300);
        }
        else if (event.target.value.length == 0) {
            clearTimeout(this.timeoutImportQuestion);
            this.timeoutImportQuestion = setTimeout(() => {
                this.getQuestionTemplateDashBoard(this.SearchQuestPopUP, this.skipPopQ, this.pageSizePopQ, this.sortField, this.sortDir);
            }, 300);
        }
    }
    importGridCellClick(event) {
        this.popUpQuestTemp();
        this.importQuestionControls(event.dataItem.FieldOptionsCatId);
    }
    importQuestionControls(QuestionTemplateID) {
        this.loading = true;
        this.refTrackingService.importQuestionControls(QuestionTemplateID).subscribe(data => {
            this.loading = false;
            if (JSON.parse(data).ErrorCode == 0) {
                let v: number;
                v = this.refTrackingService.Step[this.ImportIndexSt].StepControls.length;
                for (var item in JSON.parse(data).QuestionDetails) {
                    this.refTrackingService.newAttributeSteps = {};
                    this.refTrackingService.newAttributeSteps = JSON.parse(data).QuestionDetails[item];
                    this.refTrackingService.Step[this.ImportIndexSt].StepControls.push(this.refTrackingService.newAttributeSteps);
                    this.refTrackingService.newAttributeSteps = {};
                    this.refTrackingService.Step[this.ImportIndexSt].StepControls[this.ImportIndexOp].StepOptions = [];
                    if (JSON.parse(data).QuestionDetails[item].QuestionType.toUpperCase() == 'CHECKBOX' || JSON.parse(data).QuestionDetails[item].QuestionType.toUpperCase() == 'DROPDOWN' || JSON.parse(data).QuestionDetails[item].QuestionType.toUpperCase() == 'COMBOBOX') {
                        for (var c in JSON.parse(data).QuestionDetails[item].StepOptions) {

                            let SubOption = {
                                Option: JSON.parse(data).QuestionDetails[item].StepOptions[c].Option,
                                PropertyType: JSON.parse(data).QuestionDetails[item].StepOptions[c].PropertyType
                            };
                            this.refTrackingService.Step[this.ImportIndexSt].StepControls[this.ImportIndexOp].StepOptions.push(SubOption);
                        }
                    }
                }
                this.refTrackingService.Step[this.ImportIndexSt].StepControls.splice(this.ImportIndexOp, 1);
                //  }
                this.ImportIndexSt = 0;
                this.ImportIndexOp = 0;
            }
        });

    }
    getQuestTeplateEdit(dataItem) {
        this.loading = true;
        this.refTrackingService.QuestionTemplateID = dataItem.FieldOptionsCatId;
        this.refTrackingService.GetQuestionTemplatesDetails(this.refTrackingService.QuestionTemplateID).subscribe(data => {
            if (JSON.parse(data).ErrorCode == 0) {
                this.loading = false;
                this.getResponseType();
                this.refTrackingService.selectQuestionTemplate.QuestionTemplateName = JSON.parse(data).QuestionDetails.QuestionTemplateName;
                this.refTrackingService.newAttributeQuest = {};
                this.refTrackingService.newAttributeAddOptQuest = {};
                this.refTrackingService.allQuestionTemplate = [];
                this.refTrackingService.allQustOption = [];
                this.refTrackingService.newAttributeQuest = { PropertyType: true, Option: '' };
                this.refTrackingService.newAttributeAddOptQuest = { QuestionType: '', PropertyType: '', Title: '', Options: this.refTrackingService.allQustOption, Required: false, Base64Image: '' };;
                for (var item in JSON.parse(data).QuestionDetails.Controls) {
                    this.refTrackingService.newAttributeAddOptQuest = JSON.parse(data).QuestionDetails.Controls[item];
                    this.refTrackingService.allQuestionTemplate.push(this.refTrackingService.newAttributeAddOptQuest);
                    this.refTrackingService.newAttributeAddOptQuest = {};
                    this.refTrackingService.allQuestionTemplate[item].Options = [];
                    if (JSON.parse(data).QuestionDetails.Controls[item].QuestionType.toUpperCase() == 'CHECKBOX' || JSON.parse(data).QuestionDetails.Controls[item].QuestionType.toUpperCase() == 'COMBOBOX' || JSON.parse(data).QuestionDetails.Controls[item].QuestionType.toUpperCase() == 'DROPDOWN') {
                        for (var c in JSON.parse(data).QuestionDetails.Controls[item].Options) {
                            let value: boolean;
                            // if (JSON.parse(data).QuestionDetails.Controls[item].Options[c].PropertyType.toUpperCase() == "TRUE") {
                            //     value = true;
                            // }
                            // else {
                            //     value = false;
                            // }
                            // let SubOption = {
                            //     Option: JSON.parse(data).QuestionDetails.Controls[item].Options[c].Option,
                            //     PropertyType: value
                            // };

                            let SubOption = {
                                Option: JSON.parse(data).QuestionDetails.Controls[item].Options[c].Option,
                                PropertyType: JSON.parse(data).QuestionDetails.Controls[item].Options[c].PropertyType
                            };
                            this.refTrackingService.allQuestionTemplate[item].Options.push(SubOption);
                        }
                    }

                }
                this.refTrackingService.StepCompareB = JSON.stringify(this.refTrackingService.allQuestionTemplate);
                this.showSection(2, '- Edit Question Template');
                this.refTrackingService.saveType = 3;
                this.refTrackingService.IsSaveButton = true;
            }
        });

    }
    copyPDFAddField(st, op) {
        let v: number;
        v = this.refTrackingService.Step[st].StepControls.length;
        this.refTrackingService.newAttributeAddOpt = { QuestionType: '', PropertyType: '', Title: '', Field: '', StepOptions: this.refTrackingService.StepOptions, Required: false, Base64Image: '' };
        this.refTrackingService.newAttribute = { PropertyType: true, Option: '', Fields: '' };
        this.refTrackingService.Step[st].StepControls.push(this.refTrackingService.newAttributeAddOpt);
        this.refTrackingService.newAttributeAddOpt = {};
        this.refTrackingService.Step[st].StepControls[v].StepOptions = [];
        this.refTrackingService.newAttribute = {};
        this.refTrackingService.Step[st].StepControls[v].QuestionType = this.refTrackingService.Step[st].StepControls[op].QuestionType;
        this.refTrackingService.Step[st].StepControls[v].PropertyType = this.refTrackingService.Step[st].StepControls[op].PropertyType;
        this.refTrackingService.Step[st].StepControls[v].Title = this.refTrackingService.Step[st].StepControls[op].Title;
        this.refTrackingService.Step[st].StepControls[v].Field = this.refTrackingService.Step[st].StepControls[op].Field;
        this.refTrackingService.Step[st].StepControls[v].Required = this.refTrackingService.Step[st].StepControls[op].Required;
        this.refTrackingService.Step[st].StepControls[v].Base64Image = this.refTrackingService.Step[st].StepControls[op].Base64Image;
        let ii: number = -1;
        for (ii = 0; ii <= (this.refTrackingService.Step[st].StepControls[op].StepOptions.length - 1); ii++) {
            let SubOption = {
                Option: this.refTrackingService.Step[st].StepControls[op].StepOptions[ii].Option,
                PropertyType: this.refTrackingService.Step[st].StepControls[op].StepOptions[ii].PropertyType,
                Fields: this.refTrackingService.Step[st].StepControls[op].StepOptions[ii].Fields
            };
            this.refTrackingService.Step[st].StepControls[v].StepOptions.push(SubOption);
        }
    }
    validationPDFFields(event) {
        if (this.validationPDFTemplateFieldOnChange(event.toUpperCase()) == false) {
            this.globals.notifyError("Field cannot be duplicate");
        }
    }
    QuestUp(i) {
        if (i == 0) {
            this.globals.notifyInfo("You have reached the top!");
        }
        else {
            let x: any; let y: any;
            x = this.refTrackingService.allQuestionTemplate[i];
            y = this.refTrackingService.allQuestionTemplate[i - 1];
            this.refTrackingService.allQuestionTemplate[i - 1] = x;
            this.refTrackingService.allQuestionTemplate[i] = y;
        }
    }
    QuestDown(i) {
        if (i == (this.refTrackingService.allQuestionTemplate.length - 1)) {
            this.globals.notifyInfo("You have reached the bottom!");
        }
        else {
            let x: any; let y: any;
            x = this.refTrackingService.allQuestionTemplate[i];
            y = this.refTrackingService.allQuestionTemplate[i + 1];
            this.refTrackingService.allQuestionTemplate[i + 1] = x;
            this.refTrackingService.allQuestionTemplate[i] = y;
        }
    }
    templatePDFUp(st, op) {
        if (op == 0) {
            this.globals.notifyInfo("You have reached the top!");
        }
        else {
            let x: any; let y: any;
            x = this.refTrackingService.Step[st].StepControls[op];
            y = this.refTrackingService.Step[st].StepControls[op - 1];
            this.refTrackingService.Step[st].StepControls[op - 1] = x;
            this.refTrackingService.Step[st].StepControls[op] = y;
        }

    }
    templatePDFDown(st, op) {
        if (op == (this.refTrackingService.Step[st].StepControls.length - 1)) {
            this.globals.notifyInfo("You have reached the bottom!");
        }
        else {
            let x: any; let y: any;
            x = this.refTrackingService.Step[st].StepControls[op];
            y = this.refTrackingService.Step[st].StepControls[op + 1];
            this.refTrackingService.Step[st].StepControls[op + 1] = x;
            this.refTrackingService.Step[st].StepControls[op] = y;
        }
    }
    validationQuestionSave() {
        let TitleName: string;
        let IsErrorFound: Boolean = false;
        //title validation
        for (var i in this.refTrackingService.allQuestionTemplate) {
            TitleName = this.refTrackingService.allQuestionTemplate[i].Title.toUpperCase();
            if (TitleName == "") {
                this.globals.notifyError("Title Should not be Empty");
                IsErrorFound = true;
            }
        }
        //end
        //Option validations
        let Options: string;
        for (var i in this.refTrackingService.allQuestionTemplate) {

            if (this.refTrackingService.allQuestionTemplate[i].QuestionType.toString().toUpperCase() == "STATICIMAGE") {
                if (this.refTrackingService.allQuestionTemplate[i].Base64Image == undefined ||
                    this.refTrackingService.allQuestionTemplate[i].Base64Image == "") {
                    this.globals.notifyError("Please upload a static Image.");
                    IsErrorFound = true;
                }
            }
            else if (this.refTrackingService.allQuestionTemplate[i].Options.length > 1) {
                for (var j in this.refTrackingService.allQuestionTemplate[i].Options) {
                    Options = this.refTrackingService.allQuestionTemplate[i].Options[j].Option.toUpperCase();
                    if (Options == "") {
                        this.globals.notifyError("Option Should not be Empty");
                        IsErrorFound = true;
                    }
                    if (IsErrorFound == true) { break; }
                }
            }
            if (IsErrorFound == true) { break; }
        }
        // end
        if (IsErrorFound == true) {
            return false;
        }
        else {
            return true;
        }
    }
    getStepCount() {
        for (var Count in this.refTrackingService.Step) {
            let Val: any = Number(Count) + 1;
            this.dataSteps.push(Val);
        }

    }
    validationPDFTemplateSave() {
        //step vali
        let StepTitle: string;
        let StepNumber: string;
        let IsErrorFound: Boolean = false;
        for (var Step in this.refTrackingService.Step) {
            StepNumber = this.refTrackingService.Step[Step].StepNumber;
            StepTitle = this.refTrackingService.Step[Step].StepTitle.toUpperCase();
            if (StepNumber == "") {
                this.globals.notifyError("Step Number Should not be Empty");
                IsErrorFound = true;
            }
            else if (StepTitle == "") {
                this.globals.notifyError("Step Title should not be Empty for Step #" + StepNumber);
                IsErrorFound = true;
            }
            else if (this.refTrackingService.Step[Step].StepControls.length == 1 &&
                this.refTrackingService.Step[Step].StepControls[0].QuestionType == "") {
                this.globals.notifyError("Please select atleast one question type in Step#" + StepNumber);
                IsErrorFound = true;
            }
            if (IsErrorFound == false) {
                let Options: string;
                let TitleNames: string;
                for (var i in this.refTrackingService.Step[Step].StepControls) {

                    if (this.refTrackingService.Step[Step].StepControls[i].QuestionType.toString().toUpperCase() == "STATICIMAGE") {
                        if (this.refTrackingService.Step[Step].StepControls[i].Base64Image == undefined ||
                            this.refTrackingService.Step[Step].StepControls[i].Base64Image == "") {
                            this.globals.notifyError("Please upload a static Image in Step# " + StepNumber);
                            IsErrorFound = true;
                        }
                    }
                    else if (this.refTrackingService.Step[Step].StepControls[i].StepOptions.length > 1) {
                        TitleNames = this.refTrackingService.Step[Step].StepControls[i].Title.toUpperCase();
                        for (var j in this.refTrackingService.Step[Step].StepControls[i].StepOptions) {
                            Options = this.refTrackingService.Step[Step].StepControls[i].StepOptions[j].Option.toUpperCase();
                            if (Options == "") {
                                this.globals.notifyError("Option Should not be Empty in Step# " + StepNumber + " under Title: " + TitleNames);
                                IsErrorFound = true;
                            }
                            if (IsErrorFound == true) { break; }
                        }
                    }
                    if (IsErrorFound == true) { break; }
                }
            }
        }
        //=== Field Validation
        let QuestionTypeFV: string;
        let FieldNameFV: string = "";
        let IsExit: boolean = false;
        let IsFieldNull: boolean = false;
        let StepNumberFV: number = 0;
        let QuestionTitleFV: string = "";
        let StepNumberRtnFV: number = 0;
        let QuestionTitleRtnFV: string = "";
        for (var Step in this.refTrackingService.Step) {
            StepNumberFV = Number(this.refTrackingService.Step[Step].StepNumber);
            for (var StepControl in this.refTrackingService.Step[Step].StepControls) {
                QuestionTypeFV = this.refTrackingService.Step[Step].StepControls[StepControl].QuestionType.toString().toUpperCase();
                QuestionTitleFV = this.refTrackingService.Step[Step].StepControls[StepControl].Title.toString();
                if (QuestionTypeFV == "CHECKBOX" || QuestionTypeFV == "COMBOBOX" || QuestionTypeFV == "DROPDOWN") {
                    for (var StepOption in this.refTrackingService.Step[Step].StepControls[StepControl].StepOptions) {
                        FieldNameFV = this.refTrackingService.Step[Step].StepControls[StepControl].StepOptions[StepOption].Fields.toString();

                        if (FieldNameFV == undefined || FieldNameFV == "") {
                            IsExit = true;
                            IsFieldNull = true;
                        }
                        else {
                            var ValueTuple: [boolean, string, string] = this.validationPDFTemplateField(FieldNameFV.toUpperCase());

                            if (ValueTuple[0] == false) {
                                StepNumberRtnFV = Number(ValueTuple[1]);
                                QuestionTitleRtnFV = ValueTuple[2].toString();
                                IsExit = true;
                                IsFieldNull = false;
                            }
                        }

                        if (IsExit == true) {
                            break;
                        }
                    }
                }
                else if (QuestionTypeFV == "TEXT" || QuestionTypeFV == "DATEPICKER" || QuestionTypeFV == "TEXTAREA" || QuestionTypeFV == "SIGNATURE") {
                    FieldNameFV = this.refTrackingService.Step[Step].StepControls[StepControl].Field.toString();
                    if (FieldNameFV == undefined || FieldNameFV == "") {
                        IsExit = true;
                        IsFieldNull = true;
                    }
                    else {
                        var ValueTuple: [boolean, string, string] = this.validationPDFTemplateField(FieldNameFV.toUpperCase());

                        if (ValueTuple[0] == false) {
                            StepNumberRtnFV = Number(ValueTuple[1]);
                            QuestionTitleRtnFV = ValueTuple[2].toString();
                            IsExit = true;
                            IsFieldNull = false;
                        }
                    }
                }
                if (IsExit == true) {
                    break;
                }
            }
            if (IsExit == true) {
                break;
            }
        }

        if (IsExit == true && IsFieldNull == true) {
            this.globals.notifyError("Field should be selected in Step # " + StepNumberFV.toString() + " for Title: " + QuestionTitleFV);
            IsErrorFound = true;
        }
        else if (IsExit == true && IsFieldNull == false) {
            this.globals.notifyError("Field should not be duplicated. Check Step# " + StepNumberFV.toString() + " and Title: " + QuestionTitleFV + " with Step# " + StepNumberRtnFV + " and Title: " + QuestionTitleRtnFV);
            IsErrorFound = true;
        }

        if (IsErrorFound == true) {
            return false;
        }
        else {
            return true;
        }
    }
    validationPDFTemplateField(FieldName) {
        var rtnTuple: [boolean, string, string] = [true, "StepNumber", "QuestionTitle"];
        FieldName = FieldName.toUpperCase();
        let QuestionTypeFV: string;
        let FieldNameFV: string = "";
        let ExistCount: number = 0;
        let StepNumberFV: number = 0;
        let QuestionTitleFV: string = "";

        for (var Step in this.refTrackingService.Step) {
            StepNumberFV = Number(this.refTrackingService.Step[Step].StepNumber);
            for (var StepControl in this.refTrackingService.Step[Step].StepControls) {
                QuestionTypeFV = this.refTrackingService.Step[Step].StepControls[StepControl].QuestionType.toString().toUpperCase();
                QuestionTitleFV = this.refTrackingService.Step[Step].StepControls[StepControl].Title.toString();
                if (QuestionTypeFV == "CHECKBOX" || QuestionTypeFV == "COMBOBOX" || QuestionTypeFV == "DROPDOWN") {
                    for (var StepOption in this.refTrackingService.Step[Step].StepControls[StepControl].StepOptions) {
                        FieldNameFV = this.refTrackingService.Step[Step].StepControls[StepControl].StepOptions[StepOption].Fields.toString().toUpperCase();

                        if (FieldNameFV == FieldName) {
                            ExistCount = (ExistCount + 1);
                        }
                        if (ExistCount > 1) {
                            break;
                        }
                    }
                }
                else if (QuestionTypeFV == "TEXT" || QuestionTypeFV == "DATEPICKER" || QuestionTypeFV == "TEXTAREA") {
                    FieldNameFV = this.refTrackingService.Step[Step].StepControls[StepControl].Field.toString().toUpperCase();
                    if (FieldNameFV == FieldName) {
                        ExistCount = (ExistCount + 1);
                    }
                }
                if (ExistCount > 1) {
                    break;
                }
            }
            if (ExistCount > 1) {
                break;
            }
        }
        if (ExistCount > 1) {
            rtnTuple[0] = false;
            rtnTuple[1] = StepNumberFV.toString();
            rtnTuple[2] = QuestionTitleFV;
        }
        else {
            rtnTuple[0] = true;
            rtnTuple[1] = StepNumberFV.toString();
            rtnTuple[2] = QuestionTitleFV;
        }

        return rtnTuple;

    }

    validationPDFTemplateFieldOnChange(FieldName) {
        FieldName = FieldName.toUpperCase();
        let QuestionTypeFV: string;
        let FieldNameFV: string = "";
        let ExistCount: number = 0;
        for (var Step in this.refTrackingService.Step) {
            for (var StepControl in this.refTrackingService.Step[Step].StepControls) {
                QuestionTypeFV = this.refTrackingService.Step[Step].StepControls[StepControl].QuestionType.toString().toUpperCase();
                if (QuestionTypeFV == "CHECKBOX" || QuestionTypeFV == "COMBOBOX" || QuestionTypeFV == "DROPDOWN") {
                    for (var StepOption in this.refTrackingService.Step[Step].StepControls[StepControl].StepOptions) {
                        FieldNameFV = this.refTrackingService.Step[Step].StepControls[StepControl].StepOptions[StepOption].Fields.toString().toUpperCase();

                        if (FieldNameFV == FieldName) {
                            ExistCount = (ExistCount + 1);
                        }
                        if (ExistCount > 0) {
                            break;
                        }
                    }
                }
                else if (QuestionTypeFV == "TEXT" || QuestionTypeFV == "DATEPICKER" || QuestionTypeFV == "TEXTAREA") {
                    FieldNameFV = this.refTrackingService.Step[Step].StepControls[StepControl].Field.toString().toUpperCase();
                    if (FieldNameFV == FieldName) {
                        ExistCount = (ExistCount + 1);
                    }
                }
                if (ExistCount > 0) {
                    break;
                }
            }
            if (ExistCount > 0) {
                break;
            }
        }

        if (ExistCount > 0) {
            return false;
        }
        else {
            return true;
        }

    }
    propertyCheckQuest(event, i, j) {
        if (this.refTrackingService.allQuestionTemplate[i].QuestionType == 'dropdown') {
            let k: number = 0;
            if (this.refTrackingService.allQuestionTemplate[i].Options.length > 1) {
                for (k = 0; k < this.refTrackingService.allQuestionTemplate[i].Options.length; k++) {
                    if (this.refTrackingService.allQuestionTemplate[i].Options[k].PropertyType == event.toElement.checked && j != k) {
                        this.refTrackingService.allQuestionTemplate[i].Options[k].PropertyType = false;
                    }
                }
            }
        }
    }
    propertyCheckPDF(event, st, op, i) {
        if (this.refTrackingService.Step[st].StepControls[op].QuestionType == 'dropdown') {
            let k: number = 0;
            if (this.refTrackingService.Step[st].StepControls[op].StepOptions.length > 1) {
                for (k = 0; k < this.refTrackingService.Step[st].StepControls[op].StepOptions.length; k++) {
                    if (this.refTrackingService.Step[st].StepControls[op].StepOptions[k].PropertyType == event.toElement.checked && i != k) {
                        this.refTrackingService.Step[st].StepControls[op].StepOptions[k].PropertyType = false;
                    }
                }
            }
        }
    }
    stepNumberChange(event, st) {
        this.array_move(this.refTrackingService.Step, st, event - 1);
        for (var val in this.refTrackingService.Step) {
            let StepNo: Number = Number(val) + 1;
            this.refTrackingService.Step[val].StepNumber = StepNo.toString();
        }

    }
    array_move(arr, old_index, new_index) {
        if (new_index >= arr.length) {
            var k = new_index - arr.length + 1;
            while (k--) {
                arr.push(undefined);
            }
        }
        arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
        // return arr; // for testing
    };

    public closeIsDefault(status) {
        if (status == "1") {
            this.OpenIsDefault = false;
        }
        else if (status == "0") {
            this.refTrackingService.IsDefaultTemplate = false;
            this.OpenIsDefault = false;
        }

    }

    isDefaultClick(e) {
        if (e == true) {
            this.OpenIsDefault = true;
        }
    }
    getDifference(obj1, obj2) {
        var value = JSON.stringify(obj1) === JSON.stringify(obj2);
        return value;
    }
    validateEmailList(raw) {
        var emails = raw.split(',');
        var valid = 0;
        var regex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

        for (var i = 0; i < emails.length; i++) {
            if (emails[i] === "" || !regex.test(emails[i].replace(/\s/g, ""))) {
                valid = 1;
            }
        }
        return valid;
    }
    public StaticIst: number = 0;
    public StaticIop: number = 0;
    public StaticType: string = null;
    fileUploadPDFStaticImage(evt, st, op, Type) {
        this.Base64ImageStatic = null;
        this.fileType = null;
        this.StaticIst = st;
        this.StaticIop = op;
        this.StaticType = Type;
        var files = evt.target.files;
        var file = files[0];
        if (files && file) {
            var reader = new FileReader();
            this.PdfFileName = file.name;
            reader.onload = this._handleReaderLoaded.bind(this);
            reader.readAsBinaryString(file);
            this.fileType = file.type;
        }
    }
    _handleReaderLoaded(readerEvt) {
        var binaryString = readerEvt.target.result;
        this.Base64ImageStatic = "data:" + this.fileType + ";base64," + btoa(binaryString);
        if (this.StaticType == 'P') {
            this.refTrackingService.Step[this.StaticIst].StepControls[this.StaticIop].Title = this.PdfFileName;
            this.refTrackingService.Step[this.StaticIst].StepControls[this.StaticIop].Base64Image = this.Base64ImageStatic;
        }
        else if (this.StaticType == 'Q') {
            this.refTrackingService.allQuestionTemplate[this.StaticIst].Title = this.PdfFileName;
            this.refTrackingService.allQuestionTemplate[this.StaticIst].Base64Image = this.Base64ImageStatic;
        }

        this.StaticIst = 0;
        this.StaticIop = 0;
        this.PdfFileName = null;
        this.StaticType = null;
    }
    getJson() {
        this.refTrackingService.getJson().subscribe(data => {
            if (JSON.parse(data).ErrorCode == "0") {
                this.dataJSON = JSON.parse(data).ItemDetails;
            }

        });
    }
    getJsonPreview() {
        this.refTrackingService.getJsonPreview(this.refTrackingService.TemplateIdNewTemp).subscribe(data => {
            if (JSON.parse(data).ErrorCode == "0") {
                var Json = JSON.parse(data).JsonPreview;
                this.refTrackingService.JsonPreview = JSON.stringify(Json, undefined, 4);;
            }

        });
    }
    addCustomer(i) {
        this.refTrackingService.newAttributeAddCustomer = {
            CustomerID: '00000000-0000-0000-0000-000000000000', SentWithInvoice: false, SavePDFCopy: false, SendEmail: false,
            EmailAddresses: '', ConnectToAPI: false, UserKey: '', PassKey: '', IsActive: false, IsDefaultTemplate: false,
            CustomerConfigID: '00000000-0000-0000-0000-000000000000',
            PostURL: ''
        };
        this.refTrackingService.TemplateConfig.push(this.refTrackingService.newAttributeAddCustomer);
        this.refTrackingService.newAttributeAddCustomer = {};
    }
    public CustTopIndex: Number = null;
    deleteCusomer(i) {
        if (this.refTrackingService.TemplateConfig.length >= 0) {
            this.refTrackingService.deleteStatus = "DCUSTOMER";
            this.CustTopIndex = i;
            this.opendDalogeDelete = true;
        }
    }
    public filterChange(filter: any): void {
        if (filter == "") {
            filter = "0";
        }
        this.getCustomers(filter, this.refTrackingService.TemplateId);
    }
    cancelConfigurations() {
        this.showSection(0, '');
    }
    onTabSelect(e) {
        this.selectedTab = e.index;
    }
    public OpenPdFConfirmation = false;
    public OpenPdFConfirmationClick(status) {
        if (status == "1") {
            this.saveNewTemplate();
            this.OpenPdFConfirmation = false;
        }
        else if (status == "0") {
            this.OpenPdFConfirmation = false;
        }

    }
    //09102020 mm dd yy Vishnu
    getFieldType() {
        this.refTrackingService.getFieldType().subscribe(
            {
                next: data => {
                    this.dataFieldType = JSON.parse(data).ItemDetails;
                },
                error: (e) => {
                    console.error(e);
                }
            });
    }
    //Vishnu Option Up Down 14-09-2021
    QuestUpOption(Ind, J) {
        if (J == 0) {
            this.globals.notifyInfo("You have reached the top!");
        }
        else {
            let x: any; let y: any;
            x = this.refTrackingService.allQuestionTemplate[Ind].Options[J];
            y = this.refTrackingService.allQuestionTemplate[Ind].Options[J - 1];
            this.refTrackingService.allQuestionTemplate[Ind].Options[J - 1] = x;
            this.refTrackingService.allQuestionTemplate[Ind].Options[J] = y;
        }
    }
    QuestDownOption(Ind, J) {
        if (J == (this.refTrackingService.allQuestionTemplate[Ind].Options.length - 1)) {
            this.globals.notifyInfo("You have reached the bottom!");
        }
        else {
            let x: any; let y: any;
            x = this.refTrackingService.allQuestionTemplate[Ind].Options[J];
            y = this.refTrackingService.allQuestionTemplate[Ind].Options[J + 1];
            this.refTrackingService.allQuestionTemplate[Ind].Options[J + 1] = x;
            this.refTrackingService.allQuestionTemplate[Ind].Options[J] = y;
        }
    }
    templatePDFUpOption(st, op, i) {
        if (i == 0) {
            this.globals.notifyInfo("You have reached the top!");
        }
        else {
            let x: any; let y: any;
            x = this.refTrackingService.Step[st].StepControls[op].StepOptions[i];
            y = this.refTrackingService.Step[st].StepControls[op].StepOptions[i - 1];
            this.refTrackingService.Step[st].StepControls[op].StepOptions[i - 1] = x;
            this.refTrackingService.Step[st].StepControls[op].StepOptions[i] = y;
        }

    }
    templatePDFDownOption(st, op, i) {
        if (i == (this.refTrackingService.Step[st].StepControls[op].StepOptions.length - 1)) {
            this.globals.notifyInfo("You have reached the bottom!");
        }
        else {
            let x: any; let y: any;
            x = this.refTrackingService.Step[st].StepControls[op].StepOptions[i];
            y = this.refTrackingService.Step[st].StepControls[op].StepOptions[i + 1];
            this.refTrackingService.Step[st].StepControls[op].StepOptions[i + 1] = x;
            this.refTrackingService.Step[st].StepControls[op].StepOptions[i] = y;
        }
    }
    public filterSettings: DropDownFilterSettings = {
        caseSensitive: false,
        operator: 'contains'
    };

    public copyPDFTemplate(dataItem) {
        this.loading = true;
        let model = {
            TemplateId: dataItem.TemplateId,
            VersionUniqueID: dataItem.VersionUniqueID,
            PdfFileName: dataItem.PDFActualName,
        };
        this.refTrackingService.copyPDFTemplate(model).subscribe(data => {
            if (JSON.parse(data).ErrorCode == "0") {
                this.getPDFTemplateDashBoard(this.templatePDFSearch, this.skipT, this.pageSizeT, this.sortFieldT, this.sortDirT);
                this.loading = false;
                this.globals.notifySuccess("Copied to new template Successfully");
            }
        });
    }

    public copyQuestionTemplate(dataItem) {
        this.loading = true;
        let TemplateId: string = dataItem.FieldOptionsCatId; // =QuestionTemplateId
        this.refTrackingService.CopyQuestionTemplate(TemplateId).subscribe(data => {
            if (JSON.parse(data).ErrorCode == "0") {
                this.getQuestionTemplateDashBoard(this.questionTemplateSearch, this.skipQ, this.pageSizeQ, this.sortField, this.sortDir);
                this.loading = false;
                this.globals.notifySuccess("New question template copied successfully");
            }
        });
    }

    downloadPDF() {
        this.refTrackingService.downloadFile(this.refTrackingService.TemplateIdNewTemp).subscribe((data: any) => {
            let blob: any = new Blob([data], { type: data.type.toString() });
            saveAs(blob, this.refTrackingService.PDFFileName);
        }),
            (error: any) => console.log('Error downloading the file');
    }
}
